/**
 * Persist the signed-in user's interface language. Hits GET/PUT
 * /api/users/me/ui-locale. Unknown / missing values return null so the
 * client can keep the device (localStorage) pick.
 */

import { isUiLocale, type TUiLocale } from "@lexicanon/shared"
import { api } from "./client.ts"
import { unwrap } from "./errors.ts"

function coerceLocale(value: unknown): TUiLocale | null {
  return isUiLocale(value) ? value : null
}

/** Read the signed-in user's interface language. Unknown / missing → null. */
export async function getUiLocale(): Promise<TUiLocale | null> {
  const response = unwrap(await api.api.users.me["ui-locale"].get())
  return coerceLocale(response.data.locale)
}

/** Persist the signed-in user's interface language. */
export async function updateUiLocale(locale: TUiLocale): Promise<TUiLocale> {
  const response = unwrap(await api.api.users.me["ui-locale"].put({ locale }))
  const saved = coerceLocale(response.data.locale)
  if (!saved) {
    throw new Error("Could not save interface language")
  }
  return saved
}
